const propMap = {
  year     : (item: any) => item.article.year || "",
  month    : (item: any) => item.article.month || "",
  rating   : (item: any) => item.user_data && item.user_data.rating,
  keywords : (item: any) => item.user_data
                              && item.user_data.tags
                              && item.user_data.tags.join(),
}

export { propMap }
